import script from "./BadgedCart.vue?vue&type=script&setup=true&lang=ts"
export * from "./BadgedCart.vue?vue&type=script&setup=true&lang=ts"

import "./BadgedCart.vue?vue&type=style&index=0&id=0996922d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0996922d"]])

export default __exports__